import CircularProgress from "@mui/material/CircularProgress";


const LoadingLogoSmall = ({ message }) => {
    return (
        <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            color: "#fff",
            padding: "20px",
            borderRadius: "5px",
            textAlign: "center",
            zIndex: 1000
        }}>
            <CircularProgress style={{ color: "#94cfec", marginBottom: "10px" }} />
            <div>{ message }</div>
        </div>
    )
}

export default LoadingLogoSmall;
